import React from 'react';
import { SITE } from '../../data/site';
export function MapEmbed({
  className = ''
}: {
  className?: string;
}) {
  return <iframe title="Map to Bass Pro Shops, 8200 Dean Martin Dr, Las Vegas" src={SITE.location.mapEmbed} loading="lazy" referrerPolicy="no-referrer-when-downgrade" className={`w-full border-0 grayscale-[35%] ${className}`} data-id="element-487" data-mp="1hl34rpja6x7u" />;
}